export interface Capability {
  icon: string;
  title: string;
  description: string;
}

const capabilities: Capability[] = [
  {
    icon: "⚡",
    title: "Tactical Systems Integration",
    description: "Rapid deployment and interoperability architectures across land, maritime, and air command networks."
  },
  {
    icon: "🔒",
    title: "Zero-Trust Cyber Defense",
    description: "Multi-layered perimeter defense, continuous identity validation, and proactive threat neutralisation."
  },
  {
    icon: "🤖",
    title: "Autonomous Decision Support",
    description: "Edge telemetry and predictive mission algorithms delivering real-time actionable situational intelligence."
  },
  {
    icon: "🌐",
    title: "Resilient Mesh Communications",
    description: "Hardened, jam-resistant tactical communications engineered to perform in contested, degraded environments."
  }
];

export function renderCapabilities(): string {
  const cardsHtml = capabilities
    .map(
      (c) => `
    <div class="card">
      <div class="card-icon">${c.icon}</div>
      <h3 class="card-title">${c.title}</h3>
      <p class="card-description">${c.description}</p>
    </div>
  `
    )
    .join('');

  return `
    <section class="section" id="capabilities">
      <div class="section-header">
        <h2 class="section-title">Core Capabilities</h2>
        <p class="section-subtitle">Engineered for resilience, precision, and multi-domain superiority.</p>
      </div>
      <div class="grid">
        ${cardsHtml}
      </div>
    </section>
  `;
}

